<ng-container [formGroup]="group()"
              cdkDropListGroup>
  <label [for]="id + '-url'" i18n>URL:</label>
  <div class="form-array">
    <input [id]="id + '-url'" name="url" type="text" formControlName="url">
    <button type="button" (click)="alts.addLink('')" i18n-title title="+ Add another alternate URL" i18n>📎️</button>
  </div>
  <app-links #alts
             [id]="id + '-alts'"
             fieldName="alternateUrls"
             i18n-label label="Alts:"
             [showLabel]="dropping() || !!alts.count()"
             i18n-emoji emoji="📎️"
             [showAdd]="false"
             [group]="group()"
             [class.no-margin]="!dropping() && !alts.count()" />

  <label [for]="id + '-title'" i18n>Title:</label>
  <div class="form-array">
    <input [id]="id + '-title'"
           name="title"
           type="text"
           [formControl]="title()"
           (blur)="validate($any($event.target))">
    @if (web()) {
      @if (scrapingTitle()) {
        <app-loading class="event-loading"
                     [inline]="true"
                     i18n-title title="Scrape Title" />
      } @else {
        <button type="button" class="scrape-title" (click)="scrapeTitle(true)" i18n-title title="Scrape Title" i18n>🪝</button>
      }
    }
  </div>

  <label [for]="id + '-published'" i18n>Published:</label>
  <div class="form-array">
    <input [id]="id + '-published'"
           name="published"
           type="datetime-local"
           step="1"
           [formControl]="published()"
           (blur)="validate($any($event.target))">
    @if (web()) {
      @if (scrapingPublished()) {
        <app-loading class="event-loading"
                     [inline]="true"
                     i18n-title title="Scrape Published" />
      } @else {
        <button type="button" (click)="scrapePublished()" i18n-title title="Scrape Published" i18n>🪝</button>
      }
    }
    <button type="button" (click)="sources.addLink('')" i18n-title title="+ Add another source" i18n>📜️</button>
  </div>
  <span><!-- Published Errors --></span>
  <div>
    @if (publishedRequired()) {
      <div class="error" i18n>
        Published date is required.
      </div>
    }
  </div>
  <app-links #sources
             [id]="id + '-sources'"
             fieldName="sources"
             i18n-label label="Sources:"
             [showLabel]="dropping() || !!sources.count()"
             i18n-emoji emoji="🔗️"
             [showAdd]="false"
             [group]="group()"
             [class.no-margin]="!dropping() && !sources.count()" />

  <div class="add-plugins-label">
    <label [for]="id + '-plugins'" class="mobile-inline" i18n>Add Plugin:</label>
    <app-select-plugin [picker]="true"
                       [id]="id + '-plugins'"
                       class="shrink"
                       [add]="true"
                       i18n-title title="Add Plugin"
                       (picked)="togglePlugin($event)" />
  @if (creating() && thumbnail()) {
    <div class="thumbnail-preview">
      <div class="thumbnail"
           [style.background-image]="thumbnailRefs() | thumbnail: false : false | async | cssUrl: controlState0()"
           [style.background-color]="thumbnailColor()"
           [style.background-size]="thumbnailRadius() ? 'cover' : 'contain'"
           [style.border-radius.px]="thumbnailRadius()">{{ thumbnailEmoji() }}</div>
    </div>
  }
  </div>
  <app-form-plugins #pluginsFormComponent id="plugins"
                    (togglePlugin)="togglePlugin($event)"
                    [group]="group()"
                    [values]="ref()?.plugins" />

  @if (customEditor()) {
    <span><!-- Editor --></span>
    <div class="fill-editor">
      <ngx-monaco-editor #ed
                         [formControl]="comment()"
                         [options]="codeOptions()"
                         [style.height]="'min(200px, 90vh)'"
                         appResizeHandle
                                           [hitArea]="config.mobile() ? 48 : 20" />
    </div>
  } @else {
    <label [for]="ed.id()" class="editor-label">{{ editorLabel() }}:</label><!-- TODO: Let plugins change comment label -->
    <div class="fill-editor">
      <app-editor #ed
                  class="bubble"
                  [addButton]="true"
                  [addCommentTitle]="addEditorTitle()"
                  [addCommentLabel]="addEditorLabel()"
                  [control]="comment()"
                  [tags]="tags()"
                   [url]="web() && controlState0()"
                  (scrape)="scrapeAll()"
                  [scraping]="scrapingAll()"
                  (syncEditor)="syncEditor()"
                  (syncTags)="setTags($event)"
                  (addSource)="addSource($event)"
                  (uploadCompleted)="addCompletedUpload($event)" />
    </div>
  }

  <app-tags #tagsFormComponent [group]="group()" [origin]="origin()" />

</ng-container>
